import moment from "moment";
import React from "react";

import Checkpoint from "models/checkpoint";
import { GET } from "utils/fetcher";
import { CONSTANTS } from "reducers/checkpoint";
import { usePagination } from "utils/usePagination";

const statusButterMapping = {
	[CONSTANTS.ARCHIVED]: "&archived=true",
	[CONSTANTS.NOT_ARCHIVED]: "&archived=false",
	[CONSTANTS.ON]: "&active=true",
	[CONSTANTS.OFF]: "&active=false"
};

export default function useCheckpoints(organizationId, filters, pageSize) {
	// TODO Refactor this hook to properly handle different params from single filter
	const dataGetter = React.useCallback(
		async (limit, offset) => {
			let createdParam = "";
			if (filters.created) {
				const currentDate = moment();
				const fromDate = currentDate.subtract(
					filters.created,
					"months"
				);
				createdParam = "&created_from=" + fromDate.format("YYYY-MM-DD");
			}
			let searchParam = "";
			if (filters.search) {
				searchParam = `&search=${filters.search}`;
			}
			let populationTagParam = "";
			if (filters.population_tag_id__in) {
				const populationTagIds = Array.from(
					filters.population_tag_id__in
				).map(tag => String(tag));

				const encodedPopulationTags = populationTagIds
					.map(encodeURIComponent)
					.join(",");
				populationTagParam = `&population_tag_id__in=${encodedPopulationTags}`;
			}
			// display only orga checklists
			const withEventConfigChecklists =
				"&with_event_config_checklists=false";

			return GET(
				`/bo/organizers/${organizationId}/checkpoints/?limit=${limit}&offset=${offset}&only_stats=true${statusButterMapping[
					filters.status
				] ??
					""}${createdParam}${searchParam}${withEventConfigChecklists}${populationTagParam}`
			).then(resp => {
				return {
					data: resp.data.map(c => new Checkpoint(c, organizationId)),
					totalCount: resp.headers.get("total-count")
				};
			});
		},
		[organizationId, filters]
	);

	return usePagination({
		dataGetter,
		queryKey: "checkpoints",
		keepPreviousData: false,
		extraDeps: [organizationId, filters],
		pageSize,
		debounceDelay: 200,
		refetchInterval: 15000
	});
}
